import { __assign } from "tslib";
import { StyleSheet } from "react-native";
var containerStyle = {
  marginLeft: 10,
  marginRight: 10,
  marginBottom: 5,
  marginTop: 10
};
var textStyle = {
  fontSize: 10,
  backgroundColor: "transparent",
  textAlign: "right"
};
export default {
  left: StyleSheet.create({
    container: __assign({}, containerStyle),
    text: __assign({
      color: "#aaa"
    }, textStyle)
  }),
  right: StyleSheet.create({
    container: __assign({}, containerStyle),
    text: __assign({
      color: "#fff"
    }, textStyle)
  })
};